import { render, staticRenderFns } from "./Weitu.vue?vue&type=template&id=5358c252&scoped=true"
import script from "./Weitu.vue?vue&type=script&lang=js"
export * from "./Weitu.vue?vue&type=script&lang=js"
import style0 from "./Weitu.vue?vue&type=style&index=0&id=5358c252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358c252",
  null
  
)

export default component.exports